import React from "react";
import FullPage from "./FullPage";

const Loading: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <FullPage />
    </div>
  );
};

export default Loading;
